import { Box, Typography, Avatar, CircularProgress, useMediaQuery } from '@mui/material';
import { PersonRounded } from '../../../../components/icons';
import IconReusable from '../../../../components/IconReusable';
import { toCapitalized } from '../../../../v2/Utils/Capitalize';

const ProfileCard = ({ accountDetails, originalAccountDetails, loginUser, onEdit }) => {
  const isMobile = useMediaQuery('(max-width:1279px)');
  const profileImageData = originalAccountDetails?.profile_image?.file_data;
  const profileImageType = originalAccountDetails?.profile_image?.media_type;

  const profileSrc = profileImageData
    ? `data:${profileImageType};base64,${profileImageData}`
    : loginUser?.profile_image;

  const profilerPercentage = accountDetails?.profiler_percentage;

  return (
    <Box
      sx={{
        p: 3,
        borderRadius: 2,
        boxShadow: 'none',
        background: '#fff',
        display: 'flex',
        justifyContent: 'space-between',
      }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
          <CircularProgress
            variant="determinate"
            value={100}
            size={80}
            thickness={3}
            sx={{
              color: '#F7F7F7',
              position: 'absolute',
              left: '-17%',
              top: '-17%',
              transform: 'translate(-50%, -50%) rotate(-90deg)',
            }}
          />
          {/* Filled progress ring */}
          <CircularProgress
            variant="determinate"
            value={profilerPercentage}
            size={80}
            thickness={3}
            sx={{
              color: '#008000',
              position: 'absolute',
              left: '-17%',
              top: '-17%',
              '& .MuiCircularProgress-circle': { strokeLinecap: 'round' },
              transform: 'translate(-50%, -50%) rotate(-90deg)',
            }}
          />
          <Avatar
            sx={{ width: 60, height: 60, bgcolor: '#F7F7F7' }}
            alt={originalAccountDetails?.full_name || loginUser?.full_name}
            src={profileSrc}>
            <PersonRounded width={24} height={24} fill="#666666" />
          </Avatar>
          {/* Percentage badge */}
          <Box
            sx={{
              position: 'absolute',
              bottom: -15,
              left: '50%',
              transform: 'translateX(-50%)',
              bgcolor: 'white',
              px: 1,
              py: 0.2,
              borderRadius: '12px',
              border: '1px solid #008000',
            }}>
            <Typography variant="caption" sx={{ fontSize: '0.7rem', fontWeight: 500 }}>
              {profilerPercentage}%
            </Typography>
          </Box>
        </Box>

        {/* Name, phone, email */}
        <Box sx={{ ml: 3, display: 'flex', gap: 2, flexDirection: 'column' }}>
          <Typography variant="h1">
            {toCapitalized(originalAccountDetails?.full_name)}
          </Typography>
          <Box sx={{ display: 'flex', gap: 1, flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <IconReusable name="Call1" size={16} color="#666666" />
              <Typography variant="body1" sx={{ color: '#666666' }}>
                {originalAccountDetails?.phone_no || loginUser?.phone_no}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <IconReusable name="Mail" size={16} color="#666666" />
              <Typography variant="body1" sx={{ color: '#666666' }}>
                {originalAccountDetails?.email || loginUser?.email || 'Add email'}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Edit button — only shown if onEdit is provided */}
      {onEdit && (
        <Box onClick={onEdit} sx={{ cursor: 'pointer' }}>
          <IconReusable name="Edit" size={isMobile ? 20 : 24} color="#333" />
        </Box>
      )}
    </Box>
  );
};

export default ProfileCard;
